import { LabelProps, TagProps } from '@sport1/types/web'

/**
 * @param tags - Array of tag objects
 * @param keys - Keys that condition us what kind of object we want to get
 * @param extraFilter - Additional special filter for tags
 * @returns The last tag from the given list that meets our requirements (If finds nothing - last tag).
 */
export const takeLastTagWithKeys = (
    tags: (TagProps | LabelProps)[] | undefined,
    keys?: (keyof TagProps)[] & (keyof LabelProps)[],
    extraFilter?: (tag: TagProps | LabelProps) => Boolean
) => {
    if (!tags || tags.length === 0) return undefined
    let tempTags = [...tags].reverse()
    if (extraFilter) {
        tempTags = tempTags.filter(extraFilter)
        if (tempTags.length === 0) return tags[0]
    }
    if (!keys || keys.length === 0) return tempTags[0]
    return tempTags.find(tag => keys.every(key => key in tag)) ?? tempTags[0]
}

export const takeSpecificTypeOfContext =
    (contextTypes: ('LABEL' | 'TAG')[]) => (tag: TagProps | LabelProps) =>
        contextTypes.includes(tag.contextType)
